import { Modal } from '@sb1/ffe-modals-react';
import { useProject } from '../../project-hooks/useProject';
import { useState } from 'react';
import { DesktopStartModalContainer } from './DesktopStartModalContainer';
import { IMAGE, QR, POSTER, EMBED, TVA_IMAGES } from './share-on-project-model';
import { ImageModalContainer } from './ImageModalContainer';
import { EmbedModalContainer } from './EmbedModalContainer';
import { isMobile } from '../../../utils';
import { useSelector } from 'react-redux';
import TvaImagesModalContent from '../TvaImagesModalContent';
import { getUserAgent } from '../../../utils/browserDetector';

export const DesktopShareOnProjectModal = ({ modalRef, prettyUrlToShare, trackingProperties, subprojectId }) => {
    const [showPage, setShowPage] = useState(null);
    const project = useProject();
    const userAgent = useSelector((state) => getUserAgent(state));

    const imageBaseUrl = `/api/public/project/${project.id}`;

    if (isMobile(userAgent)) {
        return null;
    }

    const renderContent = () => {
        if (showPage === IMAGE) {
            return (
                <ImageModalContainer
                    onBack={() => setShowPage(null)}
                    trackingProperties={trackingProperties}
                    heading={'Delingsbilde'}
                    subHeading={'Del bildet i sosiale medier for å vise din støtte til spleisen.'}
                    url={`${imageBaseUrl}${subprojectId ? `/subproject/${subprojectId}` : ''}/shareImage`}
                    type={'image'}
                    downloadText={'Last ned bildet'}
                />
            );
        } else if (showPage === QR) {
            return (
                <ImageModalContainer
                    onBack={() => setShowPage(null)}
                    trackingProperties={trackingProperties}
                    heading={'QR-kode'}
                    imageBorder={true}
                    subHeading={
                        'Skriv ut QR-koden og vis den frem til potensielle givere slik at det blir enklere for dem å gi.'
                    }
                    url={`${imageBaseUrl}/qr${subprojectId ? `?subprojectId=${subprojectId}` : ''}`}
                    type={'qr'}
                    downloadText={'Last ned QR-koden'}
                />
            );
        } else if (showPage === POSTER) {
            return (
                <ImageModalContainer
                    imageBorder={true}
                    onBack={() => setShowPage(null)}
                    trackingProperties={trackingProperties}
                    heading={'Plakat'}
                    subHeading={'Skriv ut en plakat og heng den opp i nærområdet ditt.'}
                    url={`${imageBaseUrl}/poster${subprojectId ? `?subprojectId=${subprojectId}` : ''}`}
                    type={'poster'}
                    downloadText={'Last ned plakaten'}
                />
            );
        } else if (showPage === EMBED) {
            return <EmbedModalContainer onBack={() => setShowPage(null)} trackingProperties={trackingProperties} />;
        } else if (showPage === TVA_IMAGES) {
            return <TvaImagesModalContent onBack={() => setShowPage(null)} trackingProperties={trackingProperties} />;
        } else {
            return (
                <DesktopStartModalContainer
                    setShowPage={setShowPage}
                    prettyUrlToShare={prettyUrlToShare}
                    trackingProperties={trackingProperties}
                    subprojectId={subprojectId}
                />
            );
        }
    };

    return (
        <Modal ref={modalRef} onClose={() => setShowPage(null)} ariaLabelledby="share-modal-title">
            {renderContent()}
        </Modal>
    );
};
